(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSizeGuide() {
      var btn = document.querySelector('.button-sizeguide');
      var drawer = document.getElementById('sg-drawer');
      var overlay = document.getElementById('sg-overlay');
      var close = document.getElementById('sg-close');

      if (!btn || !drawer) return;

      // Open drawer
      function openDrawer() {
        overlay.style.display = 'block';
        // Trigger reflow so transition works
        overlay.offsetHeight;
        overlay.classList.add('sg-active');
        drawer.classList.add('sg-active');
        document.body.style.overflow = 'hidden';
      }

      // Close drawer
      function closeDrawer() {
        overlay.classList.remove('sg-active');
        drawer.classList.remove('sg-active');
        document.body.style.overflow = '';
        setTimeout(function () {
          overlay.style.display = 'none';
        }, 300);
      }

      btn.addEventListener('click', openDrawer);
      close.addEventListener('click', closeDrawer);
      overlay.addEventListener('click', closeDrawer);

      // Close on ESC key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
    }

    // Run on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSizeGuide);
    } else {
      initSizeGuide();
    }

    // Re-init if Shopify re-renders variant picker (for dynamic sections)
    document.addEventListener('shopify:section:load', initSizeGuide);
  })();

  } catch(e) { console.error(e); }
})();
})();
